import { defineComponent as _defineComponent } from 'vue';
import { normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createTextVNode as _createTextVNode, unref as _unref } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "flex flex-col items-center gap-3 text-center"
};
const _hoisted_2 = { class: "flex flex-col items-center gap-2" };
const _hoisted_3 = { class: "text-lg font-bold leading-6 text-center text-(--text-text-heading) dark:text-(--text-text-white-default)" };
const _hoisted_4 = { class: "text-sm text-(--text-text-black-default) dark:text-(--text-text-white-default)" };
const _hoisted_5 = {
    key: 1,
    class: "flex flex-col gap-4 h-full"
};
const _hoisted_6 = { class: "flex flex-col shrink-0" };
const _hoisted_7 = { class: "text-xs font-semibold leading-5 text-(--colors-text-text-heading)" };
const _hoisted_8 = { class: "text-[10px] leading-3.5 text-(--text-text-heading) dark:text-(--text-text-white-default)" };
const _hoisted_9 = {
    key: 0,
    role: "note",
    class: "flex items-start gap-2 p-3 rounded-xl border bg-(--background-background-info) border-(--border-border-info-subtle) shrink-0"
};
const _hoisted_10 = { class: "text-xs leading-4 text-(--text-text-black-default) dark:text-(--text-text-white-default)" };
const _hoisted_11 = { class: "modal-scrollbar flex flex-col gap-3 overflow-y-auto flex-1 pr-1" };
const _hoisted_12 = { class: "flex gap-2 items-start w-full" };
const _hoisted_13 = { class: "flex-1 min-w-0 flex flex-col gap-2" };
const _hoisted_14 = { class: "flex flex-col gap-1" };
const _hoisted_15 = { class: "text-sm font-medium leading-5 text-(--text-text-black-default) dark:text-(--text-text-white-default) truncate" };
const _hoisted_16 = {
    key: 0,
    class: "text-[10px] leading-3 text-(--text-text-black-default) dark:text-(--text-text-white-default)"
};
const _hoisted_17 = { class: "flex items-center gap-4" };
const _hoisted_18 = ["aria-label", "onClick"];
const _hoisted_19 = ["aria-label", "onClick"];
import { useI18n } from 'vue-i18n';
import { useProfileStore } from '@/modules/settings/public';
import { formatDate } from '@/shared/utils/date-formatting';
import { CONTACT_DEDUP_A11Y_KEYS, useContactDedupAccessibleName, } from '../../composables/useContactDedupAccessibleName';
export default /*@__PURE__*/ _defineComponent({
    __name: 'ContactDedupPanel',
    props: {
        state: {},
        results: {},
        title: {},
        hint: {},
        maxResults: {}
    },
    emits: ["preview", "go-to"],
    setup(__props) {
        const { locale } = useI18n();
        const profileStore = useProfileStore();
        const { dedupResultAccessibleName } = useContactDedupAccessibleName();
        function formatBirthDate(isoDate) {
            return formatDate(isoDate ?? undefined, locale.value, profileStore.profile?.dateFormat);
        }
        return (_ctx, _cache) => {
            return (_openBlock(), _createElementBlock("div", {
                class: _normalizeClass(["rounded-xl border flex flex-col gap-4 p-4 flex-1 transition-colors overflow-hidden", {
                        'justify-center items-center border-(--border-border-base-soft) bg-(--background-background-selected) dark:bg-(--colors-background-subtle)': __props.state === 'initialHint' || __props.state === 'checking' || __props.state === 'noDuplicate',
                        'border-(--border-border-base-soft) bg-(--background-background-selected) dark:bg-(--colors-background-subtle)': __props.state === 'duplicateFound' || __props.state === 'duplicateFoundShared' || __props.state === 'similarFound',
                    }])
            }, [
                (__props.state === 'initialHint' || __props.state === 'checking' || __props.state === 'noDuplicate')
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        _createElementVNode("div", {
                            class: _normalizeClass(["flex items-center justify-center shrink-0 mt-1", {
                                    'size-12 rounded-full bg-white dark:bg-gray-800 border border-(--border-border-base-soft)': __props.state === 'initialHint' || __props.state === 'checking',
                                    'size-6 rounded-full bg-(--colors-icon-success)': __props.state === 'noDuplicate',
                                }])
                        }, [
                            _createElementVNode("i", {
                                "aria-hidden": "true",
                                class: _normalizeClass({
                                    'ri-user-search-line text-[28px] text-(--text-text-body-subtle)': __props.state === 'initialHint',
                                    'ri-loader-4-line text-[28px] text-(--text-text-body-subtle) animate-spin': __props.state === 'checking',
                                    'ri-check-line text-base text-white': __props.state === 'noDuplicate',
                                })
                            }, null, 2 /* CLASS */)
                        ], 2 /* CLASS */),
                        _createElementVNode("div", _hoisted_2, [
                            _createElementVNode("span", _hoisted_3, _toDisplayString(__props.title), 1 /* TEXT */),
                            _createElementVNode("span", _hoisted_4, _toDisplayString(__props.hint), 1 /* TEXT */)
                        ])
                    ]))
                    : (__props.results.length > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                            _createElementVNode("div", _hoisted_6, [
                                _createElementVNode("span", _hoisted_7, _toDisplayString(__props.title), 1 /* TEXT */),
                                _createElementVNode("span", _hoisted_8, _toDisplayString(__props.hint), 1 /* TEXT */)
                            ]),
                            (__props.state === 'duplicateFoundShared')
                                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                                    _cache[0] || (_cache[0] = _createElementVNode("i", {
                                        class: "ri-information-line text-base text-(--colors-icon-info) shrink-0 mt-0.5",
                                        "aria-hidden": "true"
                                    }, null, -1 /* CACHED */)),
                                    _createElementVNode("span", _hoisted_10, _toDisplayString(_ctx.$t('contact.create.dedup.sharedEmailBanner')), 1 /* TEXT */)
                                ]))
                                : _createCommentVNode("v-if", true),
                            _createElementVNode("div", _hoisted_11, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.results.slice(0, __props.maxResults), (result) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                        key: result.id,
                                        class: _normalizeClass(["flex flex-col p-3 rounded-xl border shrink-0", {
                                                'bg-(--background-background-info) border-(--border-border-info-subtle)': result.emailExactMatch && result.emailIsShared,
                                                'bg-(--background-background-error) border-(--border-border-error-subtle)': result.emailExactMatch && !result.emailIsShared,
                                                'bg-(--background-background-warning) border-(--border-border-warning-subtle)': !result.emailExactMatch,
                                            }])
                                    }, [
                                        _createElementVNode("div", _hoisted_12, [
                                            _createElementVNode("div", {
                                                class: _normalizeClass(["shrink-0 px-1 py-0.5 rounded text-xs font-medium text-(--text-text-black-default) whitespace-nowrap", {
                                                        'bg-(--colors-background-info)': result.emailExactMatch && result.emailIsShared,
                                                        'bg-(--colors-error-100)': result.emailExactMatch && !result.emailIsShared,
                                                        'bg-(--colors-warning-100)': !result.emailExactMatch,
                                                    }])
                                            }, _toDisplayString(result.score) + "% ", 3 /* TEXT, CLASS */),
                                            _createElementVNode("div", _hoisted_13, [
                                                _createElementVNode("div", _hoisted_14, [
                                                    _createElementVNode("span", _hoisted_15, _toDisplayString(result.fullName), 1 /* TEXT */),
                                                    (result.birthDate)
                                                        ? (_openBlock(), _createElementBlock("span", _hoisted_16, [
                                                            _createTextVNode(_toDisplayString(_ctx.$t('contact.create.dedup.birthdate')) + " ", 1 /* TEXT */),
                                                            _createElementVNode("strong", null, _toDisplayString(formatBirthDate(result.birthDate)), 1 /* TEXT */)
                                                        ]))
                                                        : _createCommentVNode("v-if", true)
                                                ]),
                                                _createElementVNode("div", _hoisted_17, [
                                                    _createElementVNode("button", {
                                                        type: "button",
                                                        class: "flex items-center gap-1.5 px-3 py-1.5 rounded-full border border-(--border-border-secondary-button) bg-white dark:bg-gray-800 text-xs font-medium text-(--text-text-black-default) dark:text-(--text-text-white-default) shrink-0 hover:bg-(--background-background-hover) transition-colors",
                                                        "aria-label": _unref(dedupResultAccessibleName)(_unref(CONTACT_DEDUP_A11Y_KEYS).preview, result.fullName, result.birthDate),
                                                        onClick: ($event) => (_ctx.$emit('preview', result))
                                                    }, [
                                                        _cache[1] || (_cache[1] = _createElementVNode("i", {
                                                            class: "ri-eye-line text-num-14",
                                                            "aria-hidden": "true"
                                                        }, null, -1 /* CACHED */)),
                                                        _createTextVNode(" " + _toDisplayString(_ctx.$t('contact.create.dedup.preview')), 1 /* TEXT */)
                                                    ], 8 /* PROPS */, _hoisted_18),
                                                    _createElementVNode("button", {
                                                        type: "button",
                                                        class: "flex items-center gap-1.5 text-xs font-medium text-(--text-text-link) hover:text-(--text-text-hover) transition-colors whitespace-nowrap",
                                                        "aria-label": _unref(dedupResultAccessibleName)(_unref(CONTACT_DEDUP_A11Y_KEYS).viewRecord, result.fullName, result.birthDate),
                                                        onClick: ($event) => (_ctx.$emit('go-to', result.id))
                                                    }, [
                                                        _createTextVNode(_toDisplayString(_ctx.$t('contact.create.dedup.viewRecord')) + " ", 1 /* TEXT */),
                                                        _cache[2] || (_cache[2] = _createElementVNode("i", {
                                                            class: "ri-arrow-right-line text-base",
                                                            "aria-hidden": "true"
                                                        }, null, -1 /* CACHED */))
                                                    ], 8 /* PROPS */, _hoisted_19)
                                                ])
                                            ])
                                        ])
                                    ], 2 /* CLASS */));
                                }), 128 /* KEYED_FRAGMENT */))
                            ])
                        ]))
                        : _createCommentVNode("v-if", true)
            ], 2 /* CLASS */));
        };
    }
});
